export const SUPER_ADMIN_PERMISSION = 'superAdminPermission';
export const GLOBAL_ADMIN_PERMISSION = '*';
